import React, { FC, useState } from 'react';
import CurrentInventoryView from '../CurrentInventoryView/CurrentInventoryView';
import UpdateInventoryView from '../UpdateInventoryView/UpdateInventoryView';
import './InventoryModule.css';

interface InventoryModuleProps {
  didComplete: () => void
}

const InventoryModule: FC<InventoryModuleProps> = ({didComplete}: InventoryModuleProps) => {
  const [updateValue, setUpdateValue] = useState(0)
  return (
    <div className="InventoryModule">
      <div className="current">
        <CurrentInventoryView valueToEdit={updateValue ?? 0} />
      </div>
      <div className="update">
        <UpdateInventoryView didComplete={didComplete} valueToUpdate={setUpdateValue} />
      </div>
    </div>
  )
};

export default InventoryModule;
